import React, { useState, useRef, useEffect } from "react";

const NiceSelect = ({ options = [], defaultValue, onChange }) => {
  const [selected, setSelected] = useState(defaultValue || (options.length > 0 ? options[0].label : ''));
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update selected when defaultValue changes (for dynamic options loading)
  useEffect(() => {
    if (defaultValue && defaultValue !== selected) {
      setSelected(defaultValue);
    }
  }, [defaultValue]);

  const handleOptionSelect = (option) => {
    setSelected(option.label);
    setIsOpen(false);
    // Call the onChange callback if provided
    if (onChange && typeof onChange === 'function') {
      onChange(option.value);
    }
  };

  return (
    <div className="nice-select-wrapper">
      <div className={`nice-select ${isOpen ? "open" : ""}`} ref={dropdownRef} onClick={() => setIsOpen(!isOpen)}>
        <span className="current">{selected}</span>
        <ul className="list">
          {options.map((option, index) => (
            <li key={index} className="option" onClick={(e) => { e.stopPropagation(); handleOptionSelect(option); }}>
              {option.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default NiceSelect;
